export const Routes = {
  Root: '/',

  // Marketing routes
  Features: '/#features',
  Faqs: '/#faqs',
  Pricing: '/pricing',
  Blog: '/blog',
  Changelog: '/changelog',
  About: '/about',
  Contact: '/contact',
  Waitlist: '/waitlist',

  // Auth routes
  Auth: '/auth',
  Login: '/auth/login',
  Register: '/auth/register',
  AuthError: '/auth/error',
  ForgotPassword: '/auth/forgot-password',
  ResetPassword: '/auth/reset-password',

  // Legal routes
  TermsOfService: '/terms',
  PrivacyPolicy: '/privacy',
  CookiePolicy: '/cookie',

  // Payment routes
  Payment: '/settings/payment',

  // Dashboard routes
  Dashboard: '/dashboard',

  // Favorites
  Favorites: '/favorites',

  // History
  History: '/history',

  // Image editor
  Generate: '/image-editor',
  ImageGenerator: '/image-generator',
  ImageToVideo: '/image-to-video',
  PhotoToAnimation: '/photo-to-animation',
  ReferenceToVideo: '/reference-to-video',
  AiVideoEditor: '/ai-video-editor',
  TextToVideo: '/text-to-video',
  VideoExtend: '/ai-video-extender',
  VideoUpscale: '/video-upscale',
  ImageUpscale: '/image-upscale',
  ImageStitch: '/image-stitch',

  // Trend pages
  DevilWearsPradaAi: '/devil-wears-prada-ai',
  RamalamaTrend: '/ramalama-trend',

  // Settings routes
  Settings: '/settings',
  SettingsProfile: '/settings/profile',
  SettingsBilling: '/settings/billing',
  SettingsCredits: '/settings/credits',
  SettingsSecurity: '/settings/security',
  SettingsFiles: '/settings/files',
  SettingsApiKeys: '/settings/apikeys',
  SettingsNotifications: '/settings/notifications',

  // Admin routes
  Admin: '/admin',
  AdminUsers: '/admin/users',
  AdminTasks: '/admin/tasks',
  AdminPrompts: '/admin/prompts',
  AdminPromptEdit: '/admin/prompts/$id/edit',
  AdminRedemptions: '/admin/redemptions',
} as const;

/** Default login redirect route */
export const DEFAULT_LOGIN_REDIRECT = Routes.Root;
